import { render, staticRenderFns } from "./AppFatCard.vue?vue&type=template&id=f7b13c18&"
import script from "./AppFatCard.vue?vue&type=script&lang=js&"
export * from "./AppFatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports